import React, { useEffect, useRef, useState } from "react";
import { fetchSankeyData } from "./sankeyUtils.js";
import SankeyFun from "./SankeyFun.js";
import useApi from "../../../../Hooks/useApi.js";
import LoadingSpinner from "../../../Shared/LoadingSpinner.js";
import ChartExportAsPNG from "../../../../Utils/ChartExportAsPng.jsx";
import { NoDataBox } from "../NoDataFoundMessage.js";


const SankeyContainer = ({ surveyId, locationId, type, cityData = null }) => {
  const svgRef = useRef(null);
  const downloadPngRef = useRef();

  const [data, setData] = useState(null);
  const [error, setError] = useState(null); 

  const { request, loading } = useApi({ isPublic: true });


  useEffect(() => {
 
    setError(null);
    setData(null);

    if (!surveyId || !locationId) {
      return;
    }

    const loadData = async () => {
      try {
        const res = await fetchSankeyData({ surveyId, locationId, type }, request);


        if (!res) {
          throw new Error("Received empty response from server.");
        }

        setData(res);

      } catch (err) {
        console.error("Sankey Fetch Error:", err.message);

        setError(err.message || "Failed to fetch chart data.");
      }

    };

    loadData();
  }, [surveyId, locationId, type, request]);


  // 2. Render Chart Effect
  useEffect(() => {
    // Clear previous error regarding rendering
    if (error === "Error generating chart visualization.") setError(null);

    if (!surveyId || !locationId || !data) {
      return;
    }


    if (!data.nodes || !data.links) {

      return;
    }

    try {
      const mappedColorObject = {};


      if (data?.colorMap?.domain && data?.colorMap?.range) {
        if (data.colorMap.domain.length !== data.colorMap.range.length) {
          console.warn("Sankey ColorMap domain and range length mismatch");
        }

        data.colorMap.domain.forEach((item, index) => {
          // Ensure range exists at this index
          if (data.colorMap.range[index]) {
            mappedColorObject[item] = data.colorMap.range[index];
          }
        });
      }

      // Clean up previous SVG content to prevent duplicate charts on re-renders
      if (svgRef.current) {
        svgRef.current.innerHTML = "";
      }
const nodeObj = {
    "name": "Carried away with desludger"
}
      if (
        data.links.length > 0 &&
        data.nodes.length > 0 
      ) {
        data.nodes.push(nodeObj)
        SankeyFun(
          { links: data.links, svgRef },
          {
            height: 800,
            width: 1600,
            nodeGroup: (d) => d.id,
          },
          mappedColorObject
        );
      }
    } catch (err) {
      console.error("Sankey Render Error:", err?.message);
      setError("Error generating chart visualization. Data may be malformed.");
    }
  }, [data, surveyId, locationId,request]);



  const getTitleByType = (currentType) => {
    try {
      switch (currentType) {
        case "Feacal_Sludge":
          return "Faecal Sludge Life Cycle";
        case "Solid_Waste":
          return "Solid Waste Life Cycle";
        default:
          return "Life Cycle";
      }
    } catch (e) {
      return "Life Cycle";
    }
  };

  const handleDownloadClick = () => {
    try {
      if (downloadPngRef.current && downloadPngRef.current.download) {
        downloadPngRef.current.download();
      } else {
        console.error("Download ref is not attached or component is missing.");
      }
    } catch (e) {
      console.error("Export failed:", e);
      alert("Failed to export image.");
    }
  }

  

  if (loading) {
    return <LoadingSpinner message="Loading Chart..." />;
  }

  if (error) {
    return (
      <div className="p-4 border border-red-200 bg-red-50 rounded h-full flex flex-col justify-center items-center">
        <h2 className="text-16 text-center text-lg text-red-500 font-semibold">
          Unable to load chart
          <br />
          <p className="text-sm text-gray-600">{error}</p>
        </h2>

      </div>
    );
  }

  if (!surveyId || !locationId || !data || !data.nodes || data.nodes.length === 0) {
    return (
    // <NoDataFoundMessageForChart/>
    <NoDataBox/>
    );
  }

  // Safe variables for Export Component
  const cityName = cityData?.city?.name || 'City';
  const cityType = cityData?.city?.type
    ? (cityData.city.type.charAt(0).toUpperCase() + cityData.city.type.slice(1).toLowerCase())
    : '';
  const cityYear = cityData?.year || 'Year';

  return (
    <>
      <button
        className="w-[100px] bg-[#2f4b7c] text-white font-bold text-xs py-2 rounded hover:bg-[#1d3557] flex items-center justify-center mb-4"
        onClick={handleDownloadClick}
        title="Download as PNG"
      >
        Export as PNG
      </button>

      <div className="custom-sankey-chart max-w-[1000px] mx-auto overflow-auto">
        <div className="sankey-chart" id={type || "sankey-chart-container"}>
          <svg ref={svgRef} width="100%" height="auto" />
        </div>
      </div>

      <ChartExportAsPNG
        ref={downloadPngRef}
        targetId={type || "sankey-chart-container"}
        targetWidth={1600} // Matched to SankeyFun width config for better resolution
        fileNamePrefix={`${getTitleByType(type)} - ${cityName} - ${cityYear}`}
        imageTitle={getTitleByType(type)}
        imageSource={`${cityName} ${cityType} - ${cityYear}`}
        titleFont="bold 20px Arial"
        sourceFont="italic 18px Arial"
        table={false}
      />
    </>
  );
};

export default SankeyContainer;